import { ContainerRegistry } from '../container-registry.class';
import { EMPTY_VALUE } from '../empty.const';
export function Service(options) {
    if (options === void 0) { options = {}; }
    return function (targetConstructor) {
        var serviceMetadata = {
            id: options.id || targetConstructor,
            type: targetConstructor,
            factory: options.factory || undefined,
            multiple: options.multiple || false,
            eager: options.eager || false,
            scope: options.scope || 'container',
            referencedBy: new Map().set(ContainerRegistry.defaultContainer.id, ContainerRegistry.defaultContainer),
            value: EMPTY_VALUE,
        };
        ContainerRegistry.defaultContainer.set(serviceMetadata);
    };
}
//# sourceMappingURL=service.decorator.js.map